import { ServiceCallsInitialState } from 'constants/interfaces'
import { actionTypes } from 'redux/actions/serviceCall'

export const initialState: ServiceCallsInitialState = {
  serviceCalls: [],
  serviceCallsDashboard: [],
  historicalServiceCalls: [],
  isLoading: false,
  dateFilter: null,
  notificationServiceCallModal: null,
}
export const serviceCallsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }
    case actionTypes.SET_SERVICE_CALLS:
      return {
        ...state,
        serviceCalls: action.payload,
      }
    case actionTypes.SET_SERVICE_CALLS_DASHBOARD:
      return {
        ...state,
        serviceCallsDashboard: action.payload,
      }
    case actionTypes.SET_DATE_FILTER:
      return {
        ...state,
        dateFilter: action.payload,
      }
    case actionTypes.SET_HISTORICAL_SERVICE_CALLS:
      return {
        ...state,
        historicalServiceCalls: action.payload,
      }
    case actionTypes.SET_NOTIFICATION_SERVICE_CALL_MODAL:
      return {
        ...state,
        notificationServiceCallModal: action.payload,
      }
    case actionTypes.PATCH_NOTIFICATION_SERVICE_CALL_MODAL:
      return {
        ...state,
        notificationServiceCallModal: state.notificationServiceCallModal
          ? { ...state.notificationServiceCallModal, ...action.payload }
          : null,
      }
    default:
      return state
  }
}
